import { z } from "zod";

export const presignedUrlItemSchema = z.object({
  uploadId: z.string(),
  presignedUrl: z.string(),
  filename: z.string(),
  // Absent (older backend, unsigned URL) parses as false via the default -
  // whether to send the matching x-amz-server-side-encryption header. S3
  // rejects a presigned PUT that carries this header when it wasn't part of
  // what was signed, and equally rejects one that omits it when it was, so
  // this must be read per-response, never assumed or cached across calls.
  requiresServerSideEncryption: z.boolean().default(false),
});

export const presignedUrlResponseSchema = z.object({
  uploads: z.array(presignedUrlItemSchema),
});

export type PresignedUrlItem = z.infer<typeof presignedUrlItemSchema>;
export type PresignedUrlResponse = z.infer<typeof presignedUrlResponseSchema>;

export interface FileUploadProgress {
  filename: string;
  uploadId: string;
  progress: number; // 0-100
  status: "pending" | "uploading" | "completed" | "error";
  error?: string;
}

export interface PresignedUploadState {
  isUploading: boolean;
  files: FileUploadProgress[];
  overallProgress: number; // 0-100
}
